import { APICallV2Get } from 'reactApp/api/APICall';

/** Запрос за доменными папками */
export class DomainFoldersApiCall extends APICallV2Get {
    _method = 'domain/folders';
}
